import React from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

const FilteredHeader = ({ title, titleMobile }) => (
  <div className='row mx-0 mx-sm--1'>
    <div className='col'>
      <MediaQuery minDeviceWidth={481}>
        <h2 className='txt-font-title color-title'>{ title }</h2>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={480}>
        <h2 className='txt-font-title color-title'>{ titleMobile }</h2>
      </MediaQuery>
    </div>
  </div>
)

FilteredHeader.propTypes = {
  title: PropTypes.string,
  titleMobile: PropTypes.string
}

export default FilteredHeader



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/FilteredShowcase/FilteredHeader.js